import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  MenuItem,
  Grid,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Controller, useForm } from "react-hook-form";
import { Environment } from "../_generated";
import { postgresVersions, rdsInstanceTypes, RdsServiceConfig } from "../rds";

export default function DatabaseCreateDialog(props: {
  open: boolean;
  environments: Environment[];
  onCancel: () => any;
  onSubmit: (serviceConfig: RdsServiceConfig) => any;
}) {
  const { register, handleSubmit, control } = useForm();

  return (
    <Dialog open={props.open}>
      <form
        onSubmit={handleSubmit((data: any) =>
          props.onSubmit(
            buildRdsServiceConfig(
              data,
              props.environments.map((env) => env.pk!)
            )
          )
        )}
      >
        <DialogTitle>New Postgres Database</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Name"
                name="name"
                inputRef={register}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="postgres_version"
                defaultValue="12"
                render={({ onChange, value, ref }) => (
                  <TextField
                    select
                    label="Version"
                    inputRef={ref}
                    value={value}
                    onChange={onChange}
                    variant="outlined"
                    fullWidth
                  >
                    {postgresVersions.map((version) => (
                      <MenuItem value={version} key={version}>
                        {version}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            {props.environments.map((environment) => (
              <>
                <FormControlLabel
                  control={
                    <Switch
                      name={environment.pk + "__enabled"}
                      inputRef={register}
                      defaultChecked
                    />
                  }
                  label={"Enabled in " + environment.name}
                />

                <Grid item xs={12}>
                  <Controller
                    control={control}
                    name={environment.pk + "__rds_instance_type"}
                    defaultValue="db.t3.micro"
                    render={({ onChange, value, ref }) => (
                      <TextField
                        select
                        inputRef={ref}
                        label={"RDS Instance Size in " + environment.name}
                        variant="outlined"
                        value={value}
                        onChange={onChange}
                        fullWidth
                      >
                        {rdsInstanceTypes.map((instanceType) => (
                          <MenuItem value={instanceType} key={instanceType}>
                            {instanceType}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>
              </>
            ))}
            {props.environments.length === 0 && (
              <Alert severity="info" style={{ margin: 10 }}>
                You haven't created any environments yet, so
                environment-specific options like{" "}
                <strong>RDS instance size</strong> are not available. You will
                be prompted to choose them when you create an environment. Until
                then no resources will be provisioned so it doesn't cost you
                anything.
              </Alert>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onCancel}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

function buildRdsServiceConfig(formData: any, environmentIds: number[]) {
  const config: RdsServiceConfig = {
    name: formData.name,
    extra_data: {
      postgres_version: formData.postgres_version,
    },
  };
  config.environment_options = environmentIds.map((envId) => ({
    environment_id: envId,
    enabled: formData[envId + "__enabled"],
    rds_instance_type: formData[envId + "__rds_instance_type"],
  }));
  return config;
}
